import { AxiosResponse } from "axios";
import { apiInstance } from "../base";
import {
    PhoneWhitelistDTO,
    CommunityAdminDTO,
    BulkCreatePhoneWhitelistResponseDTO,
    CreatePhoneWhitelistRequest,
    BulkCreatePhoneWhitelistRequest
} from "./types";

export const enableWhitelist = (): Promise<AxiosResponse<CommunityAdminDTO>> => {
    return apiInstance.handler.post<CommunityAdminDTO>('/phone-whitelist/enable');
}

export const disableWhitelist = (): Promise<AxiosResponse<CommunityAdminDTO>> => {
    return apiInstance.handler.post<CommunityAdminDTO>('/phone-whitelist/disable');
}

export const listWhitelistedPhones = (): Promise<AxiosResponse<PhoneWhitelistDTO[]>> => {
    return apiInstance.handler.get<PhoneWhitelistDTO[]>('/phone-whitelist/');
}

export const getWhitelistEntry = (id: string): Promise<AxiosResponse<PhoneWhitelistDTO>> => {
    return apiInstance.handler.get<PhoneWhitelistDTO>(`/phone-whitelist/${id}`);
}

export const createWhitelistEntry = (data: CreatePhoneWhitelistRequest): Promise<AxiosResponse<PhoneWhitelistDTO>> => {
    return apiInstance.handler.post<PhoneWhitelistDTO>('/phone-whitelist/', data);
}

export const deleteWhitelistEntry = (id: string): Promise<AxiosResponse<void>> => {
    return apiInstance.handler.delete<void>(`/phone-whitelist/${id}`);
}

export const bulkCreateWhitelistEntries = (data: BulkCreatePhoneWhitelistRequest): Promise<AxiosResponse<BulkCreatePhoneWhitelistResponseDTO>> => {
    return apiInstance.handler.post<BulkCreatePhoneWhitelistResponseDTO>('/phone-whitelist/bulk', data);
}

export const bulkCreateWhitelistEntriesFromCSV = (file: File): Promise<AxiosResponse<BulkCreatePhoneWhitelistResponseDTO>> => {
    const formData = new FormData();
    formData.append('file', file);
    
    return apiInstance.handler.post<BulkCreatePhoneWhitelistResponseDTO>('/phone-whitelist/bulk-csv', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

